import { Props as XAxisProps } from "recharts/types/cartesian/XAxis";
import { Props as YAxisProps } from "recharts/types/cartesian/YAxis";

/**
 *
 * 用法範例
 * ```
 * <XAxis
 *  tick={(props) => (
 *  <CustomXAxisTick
 *    {...{ props, ticksPaddingTop, ticksFontSize, ticksFormatter, }}
 *  />)}
 *  />
 * ```
 */

/**
 * TickForamatter 範例
 *  const TickForamatter = (value: string, index: number): string => {
 *    if(dayjs(value).isValid()) {
 *      return dayjs(value).format('YYYY');
 *    }
 *    return value;
 *  };
 */

interface CustomAxisTickProps {
  props: YAxisProps | XAxisProps;
  ticksPaddingTop?: number;
  ticksPaddingRight?: number;
  ticksFormatter?: (value: string | number) => string;
  axisTickColor?: string;
  isTickRotate?: boolean;
  textAnchor?: "start" | "middle" | "end";
  dy?: number;
}

const CustomAxisTick = ({
  props,
  ticksPaddingTop,
  ticksPaddingRight,
  ticksFormatter,
  axisTickColor,
  isTickRotate,
  textAnchor = "middle",
  dy,
}: CustomAxisTickProps) => {
  const { x, y, payload } = props as {
    x: number;
    y: number;
    payload: {
      value: string | number;
    };
  };
  return (
    <g transform={`translate(${x},${y})`}>
      <text
        textAnchor={textAnchor}
        transform={isTickRotate ? "rotate(-45)" : undefined}
      >
        <tspan
          dx={ticksPaddingRight ? -ticksPaddingRight : 0}
          dy={`${(ticksPaddingTop ?? 0) + (dy ?? 0)}em`}
          fill={axisTickColor}
          className="select-none text-xs md:text-sm"
        >
          {ticksFormatter ? ticksFormatter(payload.value) : payload.value}
        </tspan>
      </text>
    </g>
  );
};

interface CustomXAxisTickProps {
  props: XAxisProps;
  xTicksPaddingTop?: number;
  xTicksFontSize?: number;
  xTicksFormatter?: (value: string | number) => string;
  axisTickColor?: string;
  isTickRotate?: boolean;
  textAnchor?: "start" | "middle" | "end";
}

export const CustomXAxisTick = ({
  props,
  xTicksPaddingTop,
  xTicksFontSize,
  xTicksFormatter,
  axisTickColor,
  isTickRotate,
  textAnchor,
}: CustomXAxisTickProps) => (
  <CustomAxisTick
    {...{
      props,
      ticksPaddingTop: xTicksPaddingTop,
      ticksFontSize: xTicksFontSize,
      ticksFormatter: xTicksFormatter,
      axisTickColor,
      isTickRotate,
      textAnchor,
      dy: 0.71,
    }}
  />
);

interface CustomYAxisTickProps {
  props: YAxisProps;
  yTicksPaddingRight?: number;
  yTicksFontSize?: number;
  yTicksFormatter?: (value: string | number) => string;
  axisTickColor?: string;
}

export const CustomYAxisTick = ({
  props,
  yTicksPaddingRight,
  yTicksFontSize,
  yTicksFormatter,
  axisTickColor,
}: CustomYAxisTickProps) => (
  <CustomAxisTick
    {...{
      props,
      ticksPaddingRight: yTicksPaddingRight,
      ticksFontSize: yTicksFontSize,
      ticksFormatter: yTicksFormatter,
      axisTickColor,
      dy: 0.355,
    }}
  />
);
